import TeamPage from './team-page.connect'

export default TeamPage



// WEBPACK FOOTER //
// ./src/components/views/team-page/index.js